import {
  IEmailTemplate,
  CreateEmailTemplateRequest,
  UpdateEmailTemplateRequest,
  GetEmailTemplatesResponse,
  CheckLinkResult,
} from '../../types/emailTemplate/emailTemplate.types';
import {
  GET_EMAIL_TEMPLATES_REQUEST,
  GET_EMAIL_TEMPLATES_SUCCESS,
  GET_EMAIL_TEMPLATES_FAILURE,
  GET_EMAIL_TEMPLATE_REQUEST,
  GET_EMAIL_TEMPLATE_SUCCESS,
  GET_EMAIL_TEMPLATE_FAILURE,
  CREATE_EMAIL_TEMPLATE_REQUEST,
  CREATE_EMAIL_TEMPLATE_SUCCESS,
  CREATE_EMAIL_TEMPLATE_FAILURE,
  UPDATE_EMAIL_TEMPLATE_REQUEST,
  UPDATE_EMAIL_TEMPLATE_SUCCESS,
  UPDATE_EMAIL_TEMPLATE_FAILURE,
  DELETE_EMAIL_TEMPLATE_REQUEST,
  DELETE_EMAIL_TEMPLATE_SUCCESS,
  DELETE_EMAIL_TEMPLATE_FAILURE,
  GetEmailTemplatesRequestAction,
  GetEmailTemplatesSuccessAction,
  GetEmailTemplatesFailureAction,
  GetEmailTemplateRequestAction,
  GetEmailTemplateSuccessAction,
  GetEmailTemplateFailureAction,
  CreateEmailTemplateRequestAction,
  CreateEmailTemplateSuccessAction,
  CreateEmailTemplateFailureAction,
  UpdateEmailTemplateRequestAction,
  UpdateEmailTemplateSuccessAction,
  UpdateEmailTemplateFailureAction,
  DeleteEmailTemplateRequestAction,
  DeleteEmailTemplateSuccessAction,
  DeleteEmailTemplateFailureAction,
  CLEAR_EMAIL_TEMPLATE_SUCCESS,
  ClearEmailTemplateSuccessAction,
  CLEAR_EMAIL_TEMPLATE_CREATE_SUCCESS,
  ClearEmailTemplateCreateSuccessAction,
  CLEAR_EMAIL_TEMPLATE_UPDATE_SUCCESS,
  ClearEmailTemplateUpdateSuccessAction,
  CLEAR_EMAIL_TEMPLATE_ERROR,
  ClearEmailTemplateErrorAction,
  CHECK_LINKS_REQUEST,
  CHECK_LINKS_SUCCESS,
  CHECK_LINKS_FAILURE,
  CLEAR_CHECK_LINKS_RESULT,
  CheckLinksRequestAction,
  CheckLinksSuccessAction,
  CheckLinksFailureAction,
  ClearCheckLinksResultAction,
} from './emailTemplates.types';

// Get All Email Templates Actions
export const getEmailTemplatesRequest = (params?: {
  workspaceId?: string;
}): GetEmailTemplatesRequestAction => ({
  type: GET_EMAIL_TEMPLATES_REQUEST,
  payload: params,
});

export const getEmailTemplatesSuccess = (
  response: GetEmailTemplatesResponse
): GetEmailTemplatesSuccessAction => ({
  type: GET_EMAIL_TEMPLATES_SUCCESS,
  payload: response,
});

export const getEmailTemplatesFailure = (
  error: string
): GetEmailTemplatesFailureAction => ({
  type: GET_EMAIL_TEMPLATES_FAILURE,
  payload: error,
});

// Get Email Template by Campaign Actions
export const getEmailTemplateRequest = (
  ID: string
): GetEmailTemplateRequestAction => ({
  type: GET_EMAIL_TEMPLATE_REQUEST,
  payload: ID,
});

export const getEmailTemplateSuccess = (
  template: IEmailTemplate | null
): GetEmailTemplateSuccessAction => ({
  type: GET_EMAIL_TEMPLATE_SUCCESS,
  payload: template,
});

export const getEmailTemplateFailure = (
  templateId: string,
  error: string
): GetEmailTemplateFailureAction => ({
  type: GET_EMAIL_TEMPLATE_FAILURE,
  payload: { templateId, error },
});

// Create Email Template Actions
export const createEmailTemplateRequest = (
  templateData: CreateEmailTemplateRequest
): CreateEmailTemplateRequestAction => ({
  type: CREATE_EMAIL_TEMPLATE_REQUEST,
  payload: templateData,
});

export const createEmailTemplateSuccess = (
  template: IEmailTemplate
): CreateEmailTemplateSuccessAction => ({
  type: CREATE_EMAIL_TEMPLATE_SUCCESS,
  payload: template,
});

export const createEmailTemplateFailure = (
  error: string
): CreateEmailTemplateFailureAction => ({
  type: CREATE_EMAIL_TEMPLATE_FAILURE,
  payload: error,
});

// Update Email Template Actions
export const updateEmailTemplateRequest = (
  id: string,
  templateData: UpdateEmailTemplateRequest
): UpdateEmailTemplateRequestAction => ({
  type: UPDATE_EMAIL_TEMPLATE_REQUEST,
  payload: { id, data: templateData },
});

export const updateEmailTemplateSuccess = (
  template: IEmailTemplate
): UpdateEmailTemplateSuccessAction => ({
  type: UPDATE_EMAIL_TEMPLATE_SUCCESS,
  payload: template,
});

export const updateEmailTemplateFailure = (
  error: string
): UpdateEmailTemplateFailureAction => ({
  type: UPDATE_EMAIL_TEMPLATE_FAILURE,
  payload: error,
});

// Delete Email Template Actions
export const deleteEmailTemplateRequest = (
  templateId: string
): DeleteEmailTemplateRequestAction => ({
  type: DELETE_EMAIL_TEMPLATE_REQUEST,
  payload: templateId,
});

export const deleteEmailTemplateSuccess = (
  templateId: string
): DeleteEmailTemplateSuccessAction => ({
  type: DELETE_EMAIL_TEMPLATE_SUCCESS,
  payload: templateId,
});

export const deleteEmailTemplateFailure = (
  error: string
): DeleteEmailTemplateFailureAction => ({
  type: DELETE_EMAIL_TEMPLATE_FAILURE,
  payload: error,
});

export const clearEmailTemplateSuccess =
  (): ClearEmailTemplateSuccessAction => ({
    type: CLEAR_EMAIL_TEMPLATE_SUCCESS,
  });

export const clearEmailTemplateCreateSuccess =
  (): ClearEmailTemplateCreateSuccessAction => ({
    type: CLEAR_EMAIL_TEMPLATE_CREATE_SUCCESS,
  });

export const clearEmailTemplateUpdateSuccess =
  (): ClearEmailTemplateUpdateSuccessAction => ({
    type: CLEAR_EMAIL_TEMPLATE_UPDATE_SUCCESS,
  });

export const clearEmailTemplateError = (): ClearEmailTemplateErrorAction => ({
  type: CLEAR_EMAIL_TEMPLATE_ERROR,
});

// Check Links Actions
export const checkLinksRequest = (
  links: string[]
): CheckLinksRequestAction => ({
  type: CHECK_LINKS_REQUEST,
  payload: links,
});

export const checkLinksSuccess = (
  data: CheckLinkResult[]
): CheckLinksSuccessAction => ({
  type: CHECK_LINKS_SUCCESS,
  payload: data,
});

export const checkLinksFailure = (error: string): CheckLinksFailureAction => ({
  type: CHECK_LINKS_FAILURE,
  payload: error,
});

export const clearCheckLinksResult = (): ClearCheckLinksResultAction => ({
  type: CLEAR_CHECK_LINKS_RESULT,
});
